/* global axios */
import ApiClient from "./ApiClient";

// A diferencia de announcements.js (lectura, scopeada a la cuenta activa), este
// pega contra /api/v1/announcements sin account scope — mismo motivo que
// Api::V1::AnnouncementsController en el backend: el superadmin publica hacia
// cuentas donde no es miembro, así que no puede depender de un account_id en la URL.
class AnnouncementsManageAPI extends ApiClient {
  constructor() {
    super("announcements");
  }

  targets() {
    return axios.get(`${this.url}/targets`);
  }

  getManaged({ page = 1, perPage = 25 } = {}) {
    return axios.get(this.url, { params: { page, per_page: perPage } });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(payload) {
    return axios.post(this.url, { announcement: payload });
  }

  update(id, payload, { notifyAgain = false } = {}) {
    return axios.patch(`${this.url}/${id}`, {
      announcement: payload,
      notify_again: notifyAgain,
    });
  }

  destroy(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }
}

export default new AnnouncementsManageAPI();
